export default "__VITE_ASSET__ILDsGjBX__"